import { useChatSettings, ChatAPI } from '@guuru/chat-web';
import log from '@guuru/logger-web';

const useToken = function (partnerId: string) {
  const params = ChatAPI.storeRetrieveParams();
  const { loading, data: { chatSettings: { isTokenValid } = {} } = {} } =
    useChatSettings(partnerId);

  if (!partnerId) {
    return { isTokenValid: true };
  }
  if (params.token && !loading && !isTokenValid) {
    log.info('Token not valid');
    return {
      isTokenValid: false,
      tokenInvalidMessage: 'Your token is no longer valid',
    };
  }
  return { isTokenValid: true };
};

export default useToken;
